import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";

import { EditWrapper } from "../EditWrapper";
import { useNetwork } from "../../hooks/useNetwork";
import useAuth from "../../routes/login/AuthContext";
import { useNetworkContext } from "../../contexts/NetworkContext/context";
import { UpdateNetwork } from "../../services/NetworkApi";
import { LoadAllPortfolios, Portfolio } from "../../services/PortfolioApi";

interface IProps {
  isPreview?: boolean;
  portfolios?: Portfolio[];
}

export const NetworkPortfolio: React.FC<IProps> = (props) => {
  const { getAuthToken } = useAuth();
  const { updateNetworkValues } = useNetworkContext();
  const { selectedNetwork } = useNetwork();
  const [portfolios, setPortfolios] = useState<Portfolio[]>(props.portfolios || []);

  useEffect(() => {
    // Only load portfolios if not provided via props
    if (props.portfolios) {
      setPortfolios(props.portfolios);
      return;
    }

    const load = async () => {
      const results = await LoadAllPortfolios(0, await getAuthToken());
      if (results?.content) {
        setPortfolios(results?.content);
      }
    };

    load();
  }, [props.portfolios]);

  const handleUpdate = async (portfolioType: string) => {
    let portfolio = portfolios.find((x) => x.name === portfolioType);

    if (portfolio) {
      await UpdateNetwork(
        selectedNetwork.l1Id,
        { networkName: selectedNetwork.l1Name, portfolioType: portfolio.id },
        await getAuthToken()
      );
      return updateNetworkValues(selectedNetwork.l1Id, {
        portfolio: portfolio,
      });
    }
  };

  const defaultValue =
    typeof selectedNetwork.portfolio === "string"
      ? selectedNetwork.portfolio
      : selectedNetwork.portfolio?.name || "None";

  return (
    <>
      {props.isPreview && (
        <Typography variant="subtitle1">
          Portfolio type: {defaultValue}
        </Typography>
      )}
      {!props.isPreview && (
        <EditWrapper
          // isCustomValue
          options={[...portfolios.map((p) => p.name), "None"]}
          onEditSuccess={handleUpdate}
          defaultValue={defaultValue}
        >
          <Typography variant="subtitle1">
            Portfolio type: {defaultValue}
          </Typography>
        </EditWrapper>
      )}
    </>
  );
};
